import { VeltComments, VeltCommentTool } from '@veltdev/react';
import { useEffect } from 'react';
import './CommentsPopoverPage.css';

function CommentsPopoverPage() {

    const columnNames = [''];

    // 1 to 20 rows
    const rows = Array.from(Array(4).keys());

    // A to F columns
    const columns = Array.from(Array(5).keys()).map(i => String.fromCharCode(65 + i));

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    return (
        <div className="comments-spreadsheet-container">
            <VeltComments popoverMode={true} />
            <div className='comments-spreadsheet-header'>
                <div>
                    <h1 className="boujeeText">Popover mode</h1>
                    <span className="boujeeText">Hover over a cell to see the comment tool. Click to add a comment.</span>
                </div>
            </div>
            <div className='comments-spreadsheet-body'>
                <table>
                    <thead>
                        <tr>
                            <td></td>
                            {columns.map(column => <td key={column}>{column}</td>)}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            rows.map(row => (
                                <tr key={row}>
                                    <td>{row + 1}</td>
                                    {columns.map(column => (
                                        <td key={column} id={`commentsPopoverDemo_${column}${row + 1}`}>
                                            <div className='spreadsheet-cell'>
                                                <p suppressContentEditableWarning contentEditable>{column}{row + 1}</p>
                                                <VeltCommentTool targetCommentElementId={`commentsPopoverDemo_${column}${row + 1}`} />
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default CommentsPopoverPage;